export const portalMenu = [
    {
        name: 'Dashboard',
        link: '/portal-cliente/dashboard',
        icon: 'blocks'
    },
    {
        name: 'Empleados',
        link: '/portal-cliente/empleados',
        icon: 'users'
    },
    {
        name: 'Certificados',
        link: '/portal-cliente/certificados',
        icon: 'book-open'
    },
    {
        name: 'Agenda',
        link: '/portal-cliente/agenda',
        icon: 'calendar'
    },
    {
        name: 'Notificaciones',
        link: '/portal-cliente/notificaciones',
        icon: 'bell'
    },
    {
        name: 'Mi perfil',
        link: '/portal-cliente/perfil',
        icon: 'user'
    }
];
